
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

import { schedule7DataInfoType } from '@/types/Application/FamilyLawMatter/Pdf';
import GreyBoxForm from '@/components/utils/PopulateForms/components/GreyBoxForm.vue';
import ScheduleHeader from '@/components/utils/PopulateForms/components/ScheduleHeader.vue';
import NoteBox from '@/components/utils/PopulateForms/components/NoteBox.vue';
import FormPart from '@/components/utils/PopulateForms/components/FormPart.vue';

@Component({
    components:{
        UnderlineForm,
        CheckBox,
         GreyBoxForm,
         ScheduleHeader,
         NoteBox,
         FormPart
    }
})

export default class Schedule7 extends Vue {

    @Prop({required:true})
    result!: any;
    
    @Prop({required:true})
    selectedSchedules!: string[]; 
   
    dataReady = false; 
    guardInfo = {} as schedule7DataInfoType;    
    

    childrenGuardianshipFields = [
        {key:"guardianName",  label:"Full name of guardian:",  tdClass:"bg-grey  align-middle", thClass:" align-middle text-center align-middle", thStyle:"width:30%; font-size: 8pt; font-weight: bold; border: none; border-bottom: 2px solid #333; border-right: 1px solid #333; padding-left: 16px;"},
        {key:"guardianSince", label:"They have been a guardian of the child(ren) since:",   tdClass:" align-middle", thClass:" align-middle text-center align-middle", thStyle:"width:25%; font-size: 8pt; font-weight: bold; border: none; border-bottom: 2px solid #333; border-right: 1px solid #333; padding-left: 16px;"},
        {key:"childName",     label:"Name of child(ren)  You may leave blank",   tdClass:" align-middle", thClass:" align-middle text-center align-middle", thStyle:"width:30%; font-size: 8pt; font-weight: bold; border: none; border-bottom: 2px solid #333; padding-left: 16px;"}
    ]

    noteBoxFontSize = '10.5pt';
    sideNoteBoxFontSize = '9pt';

    mounted(){
        this.dataReady = false;       
        this.extractInfo();       
        this.dataReady = true;
    }
    
    public extractInfo(){
        if (this.selectedSchedules?.includes('schedule7') || this.selectedSchedules?.includes('schedule8')){
            this.guardInfo = this.getGuardianshipOfChildInfo(this.selectedSchedules.includes('schedule7'), this.selectedSchedules.includes('schedule8'));
        }        
    }

    public getGuardianshipOfChildInfo(guardian:boolean, cancel: boolean){
        let guardianshipInfo = {} as schedule7DataInfoType;

        if (guardian){
            guardianshipInfo.abtGuardian = {
                children: []
            }
            if (this.result.guardianOfChildSurvey){
                guardianshipInfo.abtGuardian.children = this.result.guardianOfChildSurvey.childrenList? this.result.guardianOfChildSurvey.childrenList:[];               
            }
        }

        if (cancel) {
            guardianshipInfo.abtCancel = {
                bestInterest: '',
                cancelDetails: [
                    {
                        guardianName: '', 
                        childName: '',
                        guardianSince: ''
                    }
                ]
            }

            if (this.result.guardianOfChildBestInterestsOfChildSurvey){
                const bestInterestInfo = this.result.guardianOfChildBestInterestsOfChildSurvey;
                guardianshipInfo.abtCancel.bestInterest = bestInterestInfo?.cancelGuradianChildBestInterest? bestInterestInfo.cancelGuradianChildBestInterest:''
            }
            if (this.result.guardianOfChildSurvey?.cancelGuardianDetails){
                if (this.result.guardianOfChildSurvey.cancelGuardianDetails?.length > 0){
                    guardianshipInfo.abtCancel.cancelDetails = [];
                }
                for (const detail of this.result.guardianOfChildSurvey.cancelGuardianDetails){
                    guardianshipInfo.abtCancel.cancelDetails.push({
                        guardianName: detail.nameOther, 
                        childName: detail.name,
                        guardianSince: Vue.filter('beautify-date')(detail.date)
                    })
                }                
            }
        }

        if (this.result.indigenousAncestryOfChildSurvey){
            const ancestryInfo = this.result.indigenousAncestryOfChildSurvey;
            if (ancestryInfo.indigenousChild == 'yes' && ancestryInfo.indigenousAncestry){
                guardianshipInfo.indigenous = true;
                guardianshipInfo.nonIndigenous = false;
                guardianshipInfo.unKnownAncestry = false;
                guardianshipInfo.ancestry ={
                    firstNation: ancestryInfo.indigenousAncestry.includes('First Nation'),
                    nisga: ancestryInfo.indigenousAncestry.includes('Nisg̲a’a'),
                    treatyFirstNation: ancestryInfo.indigenousAncestry.includes('Treaty First Nation'),
                    under12: ancestryInfo.indigenousAncestry.includes('the child is under 12 years of age and has a biological parent who is of Indigenous ancestry, including Métis and Inuit, and self-identifies as Indigenous'),
                    over12: ancestryInfo.indigenousAncestry.includes('the child is 12 years of age or older, of Indigenous ancestry, including Métis and Inuit, and self-identifies as Indigenous'),
                    acknowledge: (ancestryInfo.indigenousAncestry.includes('Nisg̲a’a') || ancestryInfo.indigenousAncestry.includes('Treaty First Nation'))? (ancestryInfo.ServeAcknowledgement == 'I acknowledge'):false
                }
            } else if (ancestryInfo.indigenousChild == 'no'){
                guardianshipInfo.indigenous = false;
                guardianshipInfo.nonIndigenous = true;
                guardianshipInfo.unKnownAncestry = false;
                guardianshipInfo.ancestry = {
                    firstNation: false,
                    nisga: false,
                    treatyFirstNation: false,
                    under12: false,
                    over12: false,
                    acknowledge: false                    
                };
            } else {
                guardianshipInfo.indigenous = false;
                guardianshipInfo.nonIndigenous = false;
                guardianshipInfo.unKnownAncestry = true;
                guardianshipInfo.ancestry = {
                    firstNation: false,
                    nisga: false,
                    treatyFirstNation: false,
                    under12: false,
                    over12: false,
                    acknowledge: false                    
                };
            } 
        }
        
        if(this.result.guardianOfChildSurvey?.applicationType?.includes('becomeGuardian')){
            guardianshipInfo.becomeGuardian = true;
        }else 
            guardianshipInfo.becomeGuardian = false;

        if(this.result.flmAdditionalDocumentsSurvey?.criminalChecked =='y' ){
            guardianshipInfo.criminalCheck = true;
        }else {
            guardianshipInfo.criminalCheck = false;
        }

        let form5unable = false;

        if(this.result.flmAdditionalDocumentsSurvey?.unableFileForms){
            for(const form of this.result.flmAdditionalDocumentsSurvey.unableFileForms){
                if(form.includes("Form 5")||form.includes("registry search")){
                    form5unable = true;
                }
            }   
        }

        if(this.result.flmAdditionalDocumentsSurvey?.isFilingAdditionalDocs=='y' ){
            guardianshipInfo.applyForCaseManagement = 'n'
        }else if(this.result.flmAdditionalDocumentsSurvey?.isFilingAdditionalDocs=='n' && form5unable){
            guardianshipInfo.applyForCaseManagement = 'y'
        }else if(this.result.flmAdditionalDocumentsSurvey?.isFilingAdditionalDocs=='n' && !form5unable){
            guardianshipInfo.applyForCaseManagement = 'n'
        }else{
            guardianshipInfo.applyForCaseManagement = ''
        }
        return guardianshipInfo;
    }  

}
